<template>
  <section class="relative bg-surface-1 overflow-hidden">
    <div class="relative px-6 lg:px-16 xl:px-40 py-16 md:py-24">
      <div class="flex items-start gap-2 mb-12 md:mb-16">
        <div class="bg-primary-dark rounded-[2px] w-3 h-3 mt-[13px] shrink-0" />
        <h2 class="font-display font-semibold text-3xl md:text-[56px] leading-tight text-white !mt-0 !mb-0">
          {{ t('home.buildForTitle') }}
        </h2>
      </div>

      <div class="flex items-stretch justify-center gap-6">
        <img
          :src="leftImgUrl"
          alt=""
          aria-hidden="true"
          class="hidden 2xl:block w-[200px] min-[1920px]:w-[280px] object-cover rounded shrink-0"
        />
        <div class="flex-1 grid grid-cols-1 lg:grid-cols-2 gap-6">
          <article
            v-for="card in cards" :key="card.key"
            class="bg-black rounded p-6 flex flex-col justify-between min-h-[340px] md:min-h-[400px] overflow-hidden"
          >
            <div class="flex items-start justify-between gap-4 flex-nowrap">
              <RouterLink
                :to="{ name: 'cases' }"
                class="inline-flex items-center gap-4 rounded bg-primary hover:bg-primary-dark text-white hover:text-white text-[18px] px-4 py-2.5 transition-colors shrink-0"
              >
                <span>{{ t('home.viewCases') }}</span>
                <VaIcon name="arrow_forward" :size="24" />
              </RouterLink>
              <span class="inline-flex items-center px-3 py-1 rounded bg-white/10 text-white text-xs uppercase tracking-wide shrink-0">
                {{ t(`home.buildFor.${card.key}.tag`) }}
              </span>
            </div>

            <div class="flex flex-col gap-4">
              <h3 class="font-display font-semibold text-2xl md:text-3xl text-white !mt-0 !mb-0">
                {{ t(`home.buildFor.${card.key}.title`) }}
              </h3>
              <p class="font-sans text-base md:text-lg text-[#a1a4a6] !mt-0 !mb-0">
                {{ t(`home.buildFor.${card.key}.body`) }}
              </p>
            </div>
          </article>
        </div>
        <img
          :src="rightImgUrl"
          alt=""
          aria-hidden="true"
          class="hidden 2xl:block w-[200px] min-[1920px]:w-[280px] object-cover rounded shrink-0"
        />
      </div>
    </div>

    <div class="absolute bottom-0 left-0 right-0 h-px bg-white/10" />
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { VaIcon } from 'vuestic-ui'
import leftImgUrl from '@/assets/images/build-for-left.webp?url'
import rightImgUrl from '@/assets/images/build-for-right.webp?url'

const { t } = useI18n()

const cards = [
  { key: 'sme' },
  { key: 'startup' },
] as const
</script>
